"use strict";

var _possibleConstructorReturn = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/srv/packages/backoffice/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var class_validator_1 = require("class-validator");

var lot_1 = require("./lot");

var pagination_1 = require("./pagination");

var WishAnswers;

(function (WishAnswers) {
  WishAnswers["Available"] = "Disponible imm\xE9diatement";
  WishAnswers["WaitList"] = "Sur liste d'attente";
  WishAnswers["Unavailable"] = "Indisponible";
  WishAnswers["Checking"] = "En cours de v\xE9rification";
})(WishAnswers = exports.WishAnswers || (exports.WishAnswers = {}));

var WishPrivateDTO = function WishPrivateDTO() {
  _classCallCheck(this, WishPrivateDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], WishPrivateDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], WishPrivateDTO.prototype, "idProgram", void 0);

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], WishPrivateDTO.prototype, "idLot", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], WishPrivateDTO.prototype, "programSlug", void 0);

__decorate([class_validator_1.IsEnum(WishAnswers), __metadata("design:type", String)], WishPrivateDTO.prototype, "answer", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], WishPrivateDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], WishPrivateDTO.prototype, "city", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], WishPrivateDTO.prototype, "postalCode", void 0);

__decorate([class_validator_1.IsUrl(), __metadata("design:type", String)], WishPrivateDTO.prototype, "picture", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], WishPrivateDTO.prototype, "reference", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], WishPrivateDTO.prototype, "price", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], WishPrivateDTO.prototype, "surface", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], WishPrivateDTO.prototype, "floor", void 0);

__decorate([class_validator_1.IsEnum(lot_1.LotTypes), __metadata("design:type", String)], WishPrivateDTO.prototype, "type", void 0);

__decorate([class_validator_1.IsEnum(lot_1.ParkingTypes), __metadata("design:type", String)], WishPrivateDTO.prototype, "parkingType", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], WishPrivateDTO.prototype, "southExposition", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], WishPrivateDTO.prototype, "northExposition", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], WishPrivateDTO.prototype, "eastExposition", void 0);

__decorate([class_validator_1.IsBoolean(), __metadata("design:type", Boolean)], WishPrivateDTO.prototype, "westExposition", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], WishPrivateDTO.prototype, "roomsCount", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], WishPrivateDTO.prototype, "balconySurface", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], WishPrivateDTO.prototype, "userEmail", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", Date)], WishPrivateDTO.prototype, "createDate", void 0);

exports.WishPrivateDTO = WishPrivateDTO;

var WishCreationDTO = function WishCreationDTO() {
  _classCallCheck(this, WishCreationDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], WishCreationDTO.prototype, "idLot", void 0);

exports.WishCreationDTO = WishCreationDTO;

var WishUpdateDTO = function WishUpdateDTO() {
  _classCallCheck(this, WishUpdateDTO);
};

__decorate([class_validator_1.IsEnum(WishAnswers), __metadata("design:type", String)], WishUpdateDTO.prototype, "answer", void 0);

exports.WishUpdateDTO = WishUpdateDTO;

var WishFilterDTO = function WishFilterDTO() {
  _classCallCheck(this, WishFilterDTO);
};

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], WishFilterDTO.prototype, "name", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], WishFilterDTO.prototype, "reference", void 0);

__decorate([class_validator_1.IsEnum(WishAnswers), class_validator_1.IsOptional(), __metadata("design:type", String)], WishFilterDTO.prototype, "answer", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], WishFilterDTO.prototype, "email", void 0);

exports.WishFilterDTO = WishFilterDTO;
var WishOrderEnum;

(function (WishOrderEnum) {
  WishOrderEnum["createDate"] = "wish.createDate";
  WishOrderEnum["name"] = "program.name";
  WishOrderEnum["reference"] = "lot.reference";
  WishOrderEnum["answer"] = "wish.answer";
  WishOrderEnum["email"] = "account.email";
})(WishOrderEnum = exports.WishOrderEnum || (exports.WishOrderEnum = {}));

var WishPaginationResponse =
/*#__PURE__*/
function (_pagination_1$Paginat) {
  _inherits(WishPaginationResponse, _pagination_1$Paginat);

  function WishPaginationResponse() {
    _classCallCheck(this, WishPaginationResponse);

    return _possibleConstructorReturn(this, _getPrototypeOf(WishPaginationResponse).apply(this, arguments));
  }

  return WishPaginationResponse;
}(pagination_1.PaginationResponse);

exports.WishPaginationResponse = WishPaginationResponse;